var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7498 0H7.24801C6.31854 0 5.57031 0.730105 5.57031 1.63705V22.3629C5.57031 23.2699 6.31854 24 7.24801 24H16.7498C17.6792 24 18.4275 23.2699 18.4275 22.3629V1.63705C18.4275 0.730105 17.6792 0 16.7498 0ZM10.3212 1.09137H13.6766C13.8293 1.09137 13.9562 1.21263 13.9562 1.36421C13.9562 1.51326 13.8293 1.63705 13.6766 1.63705H10.3212C10.1684 1.63705 10.0416 1.51326 10.0416 1.36421C10.0416 1.21263 10.1684 1.09137 10.3212 1.09137ZM13.6326 22.2644C13.6326 22.5777 13.3711 22.8328 13.05 22.8328H10.9477C10.6267 22.8328 10.3652 22.5777 10.3652 22.2644V21.9183C10.3652 21.6051 10.6267 21.3499 10.9477 21.3499H13.05C13.3711 21.3499 13.6326 21.6051 13.6326 21.9183V22.2644ZM17.309 20.1827H6.68878V2.72842H17.309V20.1827Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.0c88e6c03087cc6a4733f08a9400c4af.svg";
export { ForwardRef as ReactComponent };